import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useMemo } from "react";
import { parseValidationErrors, groupErrorsByField } from "../../../utils/acrValidationUtils";

/**
 * Hook to get validation errors mapped by field name
 * @param validationErrors ACR validation errors from API
 * @returns Object mapping field names to their error messages
 */
export function useValidationErrors(validationErrors) {
  return useMemo(function () {
    if (!validationErrors) {
      return {};
    }
    var errors = parseValidationErrors(validationErrors);
    var grouped = groupErrorsByField(errors);

    // Convert to simple field name -> error message mapping
    var fieldErrors = {};
    Object.entries(grouped).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        fieldName = _ref2[0],
        errorList = _ref2[1];
      if (fieldName !== "_general" && (errorList === null || errorList === void 0 ? void 0 : errorList.length) > 0) {
        // Join multiple errors for the same field
        fieldErrors[fieldName] = errorList.map(function (e) {
          return e === null || e === void 0 ? void 0 : e.message;
        }).join("; ");
      }
    });
    return fieldErrors;
  }, [validationErrors]);
}

/**
 * Get validation error for a specific field
 */
export function getFieldValidationError(fieldName, validationErrors) {
  if (!validationErrors) return undefined;
  var errors = parseValidationErrors(validationErrors);
  var fieldErrors = errors.filter(function (e) {
    var _e$fieldName, _e$message;
    return (e === null || e === void 0 || (_e$fieldName = e.fieldName) === null || _e$fieldName === void 0 ? void 0 : _e$fieldName.toLowerCase()) === fieldName.toLowerCase() || (e === null || e === void 0 || (_e$message = e.message) === null || _e$message === void 0 ? void 0 : _e$message.toLowerCase().includes(fieldName.toLowerCase()));
  });
  if ((fieldErrors === null || fieldErrors === void 0 ? void 0 : fieldErrors.length) === 0) return undefined;
  return fieldErrors.map(function (e) {
    return e === null || e === void 0 ? void 0 : e.message;
  }).join("; ");
}